var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotInterested(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 99,
    viewBox: "0 0 111 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_8040_11222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0092 35.8339C31.7193 28.1074 37.748 21.6088 45.4745 21.3189L63.0807 20.6585C70.8072 20.3686 77.3058 26.3973 77.5957 34.1238L78.2561 51.7299C78.546 59.4565 72.5173 65.955 64.7908 66.2449L47.1846 66.9053C39.4581 67.1952 32.9595 61.1665 32.6696 53.44L32.0092 35.8339Z",
    fill: "url(#paint0_linear_8040_11222)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_8040_11222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0092 35.8339C31.7193 28.1074 37.748 21.6088 45.4745 21.3189L63.0807 20.6585C70.8072 20.3686 77.3058 26.3973 77.5957 34.1238L78.2561 51.7299C78.546 59.4565 72.5173 65.955 64.7908 66.2449L47.1846 66.9053C39.4581 67.1952 32.9595 61.1665 32.6696 53.44L32.0092 35.8339Z",
    fill: "url(#paint1_linear_8040_11222)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8040_11222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.4931 53.3317C61.2151 53.117 65.6858 48.469 65.4788 42.95C65.2718 37.4311 60.4653 33.1311 54.7434 33.3457C49.0214 33.5604 44.5506 38.2084 44.7577 43.7273C44.9647 49.2463 49.7711 53.5463 55.4931 53.3317Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1148 40.2199L52.1234 46.4489",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8984 40.4531L58.3397 46.2157",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_8040_11222)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_8040_11222",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.616 24.7866C65.4872 21.3535 68.166 18.4659 71.5991 18.3371C75.0323 18.2083 77.9199 20.8871 78.0487 24.3203C78.1775 27.7534 75.4987 30.641 72.0655 30.7698C68.6323 30.8986 65.7448 28.2198 65.616 24.7866Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.616 24.7866C65.4872 21.3535 68.166 18.4659 71.5991 18.3371C75.0323 18.2083 77.9199 20.8871 78.0487 24.3203C78.1775 27.7534 75.4987 30.641 72.0655 30.7698C68.6323 30.8986 65.7448 28.2198 65.616 24.7866Z",
    fill: "url(#paint2_linear_8040_11222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.616 24.7866M78.0487 24.3203M78.0487 24.3203M65.616 24.7866M71.5991 18.3371M78.0487 24.3203M72.0655 30.7698M65.616 24.7866M72.0655 30.7698L71.9906 28.7712C69.6612 28.8586 67.702 27.0411 67.6146 24.7117L65.616 24.7866L63.6174 24.8616C63.7876 29.3986 67.6035 32.9386 72.1405 32.7684L72.0655 30.7698ZM78.0487 24.3203L76.0501 24.3952C76.1375 26.7246 74.3199 28.6838 71.9906 28.7712L72.0655 30.7698L72.1405 32.7684C76.6775 32.5982 80.2175 28.7823 80.0473 24.2453L78.0487 24.3203ZM71.5991 18.3371L71.6741 20.3357C74.0035 20.2483 75.9627 22.0658 76.0501 24.3952L78.0487 24.3203L80.0473 24.2453C79.8771 19.7083 76.0611 16.1683 71.5242 16.3385L71.5991 18.3371ZM71.5991 18.3371L71.5242 16.3385C66.9872 16.5087 63.4472 20.3246 63.6174 24.8616L65.616 24.7866L67.6146 24.7117C67.5272 22.3823 69.3447 20.4231 71.6741 20.3357L71.5991 18.3371Z",
    fill: "white",
    mask: "url(#path-6-inside-1_8040_11222)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8040_11222",
    x: -0.515625,
    y: -11.8672,
    width: 111.297,
    height: 111.297,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_8040_11222"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_8040_11222",
    x: 19.4844,
    y: 18.1328,
    width: 71.2969,
    height: 71.2969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8040_11222"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8040_11222"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8040_11222"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8040_11222",
    result: "effect2_dropShadow_8040_11222"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8040_11222",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_8040_11222",
    x: 53.3828,
    y: 16.1016,
    width: 36.8984,
    height: 36.8984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8040_11222"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8040_11222"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8040_11222"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8040_11222",
    result: "effect2_dropShadow_8040_11222"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8040_11222",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8040_11222",
    x1: 31.4844,
    y1: 21.8438,
    x2: 78.7809,
    y2: 65.7201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8040_11222",
    x1: 31.4844,
    y1: 21.8438,
    x2: 78.7809,
    y2: 65.7201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8040_11222",
    x1: 65.3828,
    y1: 18.5703,
    x2: 78.2819,
    y2: 30.5366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8040_11222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.8828,
    height: 24,
    fill: "white",
    transform: "translate(42.2344 31.8125) rotate(-2.14832)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotInterested);
export default __webpack_public_path__ + "static/media/Not Interested.e5b7a442aaae114b3a6aee0d8d9cfa99.svg";
export { ForwardRef as ReactComponent };